// @core/api/endpoints/workflow/get_credential.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CredentialResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get credential
 * Retrieves credential metadata. Secret values are NOT returned — only field keys and verification status.
 */
export async function GetCredential(
  credential_id: string,
  options?: RequestOptions
): Promise<CredentialResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/credentials/:credential_id`;
  requestPath = requestPath.replace(':credential_id', encodeURIComponent(credential_id));
  const requestOptions = options;
  return client.get<CredentialResponse>(requestPath, { ...requestOptions });
}
